import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const Upload: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden={!title}
      focusable='false'
      width={width}
      height={height}
      {...props}
    >
      <path
        d='M2 17V22H22V17M12 2V17M12 2L18 8M12 2L6 8'
        stroke={fill}
        strokeWidth='2'
      />
    </svg>
  )
}

export default Upload
